<template>
  <span>
    <b-modal v-if="data" header-bg-variant="info-primary" centered :title="data.title" size="lg" v-model="showModal" @close="close()" button-size="sm">
      <span v-html="data.text"></span>
      <template #modal-footer="{ cancel}">
        <b-button size="sm" variant="primary" @click="cancel()">
          OK
        </b-button>
      </template>
    </b-modal>
    <svg @click="open" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_9_4248)">
        <path d="M14 28C17.713 28 21.274 26.525 23.8995 23.8995C26.525 21.274 28 17.713 28 14C28 10.287 26.525 6.72601 23.8995 4.10051C21.274 1.475 17.713 0 14 0C10.287 0 6.72601 1.475 4.10051 4.10051C1.475 6.72601 0 10.287 0 14C0 17.713 1.475 21.274 4.10051 23.8995C6.72601 26.525 10.287 28 14 28ZM9.28594 9.03984C9.71797 7.82031 10.8773 7 12.1734 7H15.3617C17.2703 7 18.8125 8.54766 18.8125 10.4508C18.8125 11.6867 18.1508 12.8297 17.0789 13.4477L15.3125 14.4594C15.3016 15.1703 14.7164 15.75 14 15.75C13.2727 15.75 12.6875 15.1648 12.6875 14.4375V13.6992C12.6875 13.2289 12.9391 12.7969 13.3492 12.5617L15.7719 11.1727C16.0289 11.025 16.1875 10.7516 16.1875 10.4563C16.1875 9.99687 15.8156 9.63047 15.3617 9.63047H12.1734C11.9875 9.63047 11.8234 9.74531 11.7633 9.92031L11.7414 9.98594C11.5008 10.6695 10.7461 11.025 10.068 10.7844C9.38984 10.5437 9.02891 9.78906 9.26953 9.11094L9.29141 9.04531L9.28594 9.03984ZM12.25 19.25C12.25 18.7859 12.4344 18.3408 12.7626 18.0126C13.0908 17.6844 13.5359 17.5 14 17.5C14.4641 17.5 14.9092 17.6844 15.2374 18.0126C15.5656 18.3408 15.75 18.7859 15.75 19.25C15.75 19.7141 15.5656 20.1592 15.2374 20.4874C14.9092 20.8156 14.4641 21 14 21C13.5359 21 13.0908 20.8156 12.7626 20.4874C12.4344 20.1592 12.25 19.7141 12.25 19.25Z" fill="#20A8D8"/>
      </g>
      <defs>
        <clipPath id="clip0_9_4248">
          <rect width="28" height="28" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </span>
</template>

<script>
import client from "../backend/client";

export default {
  name: "Directory",
  data() {
    return {
      showModal: false,
      data: null
    }
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  methods: {
    async open() {
      this.data =  (await client.get('api/crm/directories/' + this.slug)).data
      this.showModal = true
    }
  }
}
</script>

<style lang="scss">
svg {
  cursor: pointer;
  margin-left: 10px;
}
.modal-header.bg-info-primary {
  background: #63C2DE!important;
  color: #fff;
  .modal-title {
    width: 100%;
    text-align: center;
  }
}
</style>
